<template>
  <div class="animated fadeIn personPage indicatorsPage withTabs">
    <b-tabs v-model="tab_index">
      <b-card>
        <b-tab title="Physical" active>
            <h4>Physical Indicators</h4>
            <b-list-group style="border: none">
                <b-list-group-item flush v-for="field in getFields( 'physical' )" v-bind:key="field.name" class="pl-1" style="border: none !important;">
                    <p-check large class="p-success p-round h5 p-0 m-0 p-smooth p-plain" color="success" v-model="assessment[field.name]" true-value="Yes" false-value="No" :name="field.name">{{ field.label }}</p-check>
                </b-list-group-item>
            </b-list-group>
        </b-tab>

        <b-tab title="Behavioral">
            <h4>Behavioral Indicators</h4>
            <b-list-group style="border: none">
                <b-list-group-item flush v-for="field in getFields( 'behavioral' )" v-bind:key="field.name" class="pl-1" style="border: none;">
                    <p-check large class="p-success p-round h5 p-0 m-0 p-smooth p-plain" color="success" v-model="assessment[field.name]" true-value="Yes" false-value="No" :name="field.name">{{ field.label }}</p-check>
                </b-list-group-item>
            </b-list-group>
        </b-tab>

        <b-tab title="Psychological">
            <h4>Psychological Indicators</h4>
            <b-list-group style="border: none">
                <b-list-group-item flush v-for="field in getFields( 'psychological' )" v-bind:key="field.name" class="pl-1" style="border: none;">
                    <p-check large class="p-success p-round h5 p-0 m-0 p-smooth p-plain" color="success" v-model="assessment[field.name]" true-value="Yes" false-value="No" :name="field.name">{{ field.label }}</p-check>
                </b-list-group-item>
            </b-list-group>
        </b-tab>

        <b-tab title="Medical">
            <h4>Medical Indicators</h4>
            <b-list-group style="border: none">
                <b-list-group-item flush v-for="field in getFields( 'medical' )" v-bind:key="field.name" class="pl-1" style="border: none;">
                    <p-check large class="p-success p-round h5 p-0 m-0 p-smooth p-plain" color="success" v-model="assessment[field.name]" true-value="Yes" false-value="No" :name="field.name">{{ field.label }}</p-check>
                </b-list-group-item>
            </b-list-group>
        </b-tab>

        <b-tab title="Questions">
            <h4>Questions</h4>
            <b-list-group style="border: none">
                <b-list-group-item flush class="pl-1" style="border: none;">
                    <b-form-group label-size='lg' label-class='addpersonlabel' label='Are you safe?' label-for='q_safe'>
                        <p-radio class="p-round p-smooth p-plain" name='q_safe_radio' color="success" v-model="assessment.q_safe" value="Yes">Yes</p-radio>
                        <p-radio class="p-round p-smooth p-plain" name='q_safe_radio' color="red" v-model="assessment.q_safe" value="No">No</p-radio>
                        <b-link @click="toggleDetails('q_s_det')">{{ q_s_det ? "Hide Details" : "Add Details" }}</b-link>
                        <b-form-textarea v-if="q_s_det" class="mt-3" :rows="3" placeholder="Enter Details" name='d_safe' v-model="assessment.d_safe"></b-form-textarea>
                    </b-form-group>
                </b-list-group-item>
                <b-list-group-item flush class="pl-1" style="border: none;">
                    <b-form-group label-size='lg' label-class='addpersonlabel' label='Do you want to see a doctor?' label-for='q_doctor'>
                        <p-radio class="p-round p-smooth p-plain" name='q_doctor' ref="q_doctor_on" color="success" v-model="assessment.q_doctor" value="Yes">Yes</p-radio>
                        <p-radio class="p-round p-smooth p-plain" name='q_doctor' ref="q_doctor_off" color="red" v-model="assessment.q_doctor" value="No">No</p-radio>
                        <b-link @click="toggleDetails('q_doctor_det')">{{ q_doctor_det ? "Hide Details" : "Add Details" }}</b-link>
                        <b-form-textarea v-if="q_doctor_det" class="mt-3" :rows="3" placeholder="Enter Details" name='d_doctor' v-model="assessment.d_doctor"></b-form-textarea>
                    </b-form-group>
                </b-list-group-item>
                <b-list-group-item flush class="pl-1" style="border: none;">
                    <b-form-group label-size='lg' label-class='addpersonlabel' label='Are you with anybody?' label-for='q_anybody'>
                        <p-radio class="p-round p-smooth p-plain" name='q_anybody' ref="q_anybody_on" color="success" v-model="assessment.q_anybody" value="Yes">Yes</p-radio>
                        <p-radio class="p-round p-smooth p-plain" name='q_anybody' ref="q_anybody_off" color="red" v-model="assessment.q_anybody" value="No">No</p-radio>
                        <b-link @click="toggleDetails('q_anybody_det')">{{ q_anybody_det ? "Hide Details" : "Add Details" }}</b-link>
                        <b-form-textarea v-if="q_anybody_det" class="mt-3" :rows="3" placeholder="Enter Details" name='d_anybody' v-model="assessment.d_anybody"></b-form-textarea>
                    </b-form-group>
                </b-list-group-item>
                <b-list-group-item flush class="pl-1" style="border: none;">
                    <b-form-group label-size='lg' label-class='addpersonlabel' label='Are you worried about someone finding you?' label-for='q_finding'>
                        <p-radio class="p-round p-smooth p-plain" name='q_finding' color="success" value="Yes" v-model="assessment.q_finding">Yes</p-radio>
                        <p-radio class="p-round p-smooth p-plain" name='q_finding' color="red" value="No" v-model="assessment.q_finding">No</p-radio>
                        <b-link @click="toggleDetails('q_finding_det')">{{ q_finding_det ? "Hide Details" : "Add Details" }}</b-link>
                        <b-form-textarea v-if="q_finding_det" class="mt-3" :rows="3" placeholder="Enter Details" name='d_finding' v-model="assessment.d_finding"></b-form-textarea>
                    </b-form-group>
                </b-list-group-item>
                <b-list-group-item flush class="pl-1" style="border: none;">
                    <b-form-group label-size='lg' label-class='addpersonlabel' label='Has anyone made you do something you did not want to do or made you uncomfortable?' label-for='q_do_something'>
                        <p-radio class="p-round p-smooth p-plain" name='q_do_something' color="success" value="Yes" v-model="assessment.q_do_something">Yes</p-radio>
                        <p-radio class="p-round p-smooth p-plain" name='q_do_something' color="red" value="No" v-model="assessment.q_do_something">No</p-radio>
                        <b-link @click="toggleDetails('q_do_something_det')">{{ q_do_something_det ? "Hide Details" : "Add Details" }}</b-link>
                        <b-form-textarea v-if="q_do_something_det" class="mt-3" :rows="3" placeholder="Enter Details" name='d_do_something' v-model="assessment.d_do_something"></b-form-textarea>
                    </b-form-group>
                </b-list-group-item>
                <b-list-group-item flush class="pl-1" style="border: none;">
                    <b-form-group label-size='lg' label-class='addpersonlabel' label='Have you been bullied?' label-for='q_bullied'>
                        <p-radio class="p-round p-smooth p-plain" name='q_bullied' color="success" value="Yes" v-model="assessment.q_bullied">Yes</p-radio>
                        <p-radio class="p-round p-smooth p-plain" name='q_bullied' color="red" value="No" v-model="assessment.q_bullied">No</p-radio>
                        <b-link @click="toggleDetails('q_bullied_det')">{{ q_bullied_det ? "Hide Details" : "Add Details" }}</b-link>
                        <b-form-textarea v-if="q_bullied_det" class="mt-3" :rows="3" placeholder="Enter Details" name='d_bullied' v-model="assessment.d_bullied"></b-form-textarea>
                    </b-form-group>
                </b-list-group-item>
                <b-list-group-item flush class="pl-1" style="border: none;">
                    <b-form-group label-size='lg' label-class='addpersonlabel' label='Have you ever been in a place you felt you could not leave?' label-for='d_could_not_leave'>
                        <p-radio class="p-round p-smooth p-plain" name='q_could_not_leave' ref="q_could_not_leave_on" color="success" value="Yes" v-model="assessment.q_could_not_leave">Yes</p-radio>
                        <p-radio class="p-round p-smooth p-plain" name='q_could_not_leave' ref="q_could_not_leave_off" color="red" value="No" v-model="assessment.q_could_not_leave">No</p-radio>
                        <b-link @click="toggleDetails('q_could_not_leave_det')">{{ q_could_not_leave_det ? "Hide Details" : "Add Details" }}</b-link>
                        <b-form-textarea v-if="q_could_not_leave_det" class="mt-3" :rows="3" placeholder="Enter Details" name='d_could_not_leave' v-model="assessment.d_could_not_leave"></b-form-textarea>
                    </b-form-group>
                </b-list-group-item>
                <b-list-group-item flush class="pl-1" style="border: none;">
                    <b-form-group label-size='lg' label-class='addpersonlabel' label='How do you get your basic needs met?' label-for='d_basic_needs'>
                        <b-form-textarea class="mt-1" :rows="3" placeholder="Enter Details" name='d_basic_needs' v-model="assessment.d_basic_needs"></b-form-textarea>
                    </b-form-group>
                </b-list-group-item>
                <b-list-group-item flush class="pl-1" style="border: none;">
                    <b-form-group label-size='lg' label-class='addpersonlabel' label='Tell me about school' label-for='d_school'>
                        <b-form-textarea class="mt-1" :rows="3" placeholder="Enter Details" name='d_school' v-model="assessment.d_school"></b-form-textarea>
                    </b-form-group>
                </b-list-group-item>
                <b-list-group-item flush class="pl-1" style="border: none;">
                    <b-form-group label-size='lg' label-class='addpersonlabel' label='What is the worst you have ever been hurt by someone else?' label-for='d_worst_hurt'>
                        <b-form-textarea class="mt-1" :rows="3" placeholder="Enter Details" name='d_worst_hurt' v-model="assessment.d_worst_hurt"></b-form-textarea>
                    </b-form-group>
                </b-list-group-item>
                <b-list-group-item flush class="pl-1" style="border: none;">
                    <b-form-group label-size='lg' label-class='addpersonlabel' label='Who do you hang out with?' label-for='d_hang_out'>
                        <b-form-textarea class="mt-1" :rows="3" placeholder="Enter Details" name='d_hang_out' v-model="assessment.d_hang_out"></b-form-textarea>
                    </b-form-group>
                </b-list-group-item>
                <b-list-group-item flush class="pl-1" style="border: none;">
                    <b-form-group label-size='lg' label-class='addpersonlabel' label='Who takes care of you?' label-for='d_cared_by'>
                        <b-form-textarea class="mt-1" :rows="3" placeholder="Enter Details" name='d_cared_by' v-model="assessment.d_cared_by"></b-form-textarea>
                    </b-form-group>
                </b-list-group-item>
                <b-list-group-item flush class="pl-1" style="border: none;">
                    <b-form-group label-size='lg' label-class='addpersonlabel' label='Do you wish someone else was taking care of you?' label-for='q_someone'>
                        <p-radio class="p-round p-smooth p-plain" name='q_someone' color="success" value="Yes" v-model="assessment.q_someone">Yes</p-radio>
                        <p-radio class="p-round p-smooth p-plain" name='q_someone' color="red" value="No" v-model="assessment.q_someone">No</p-radio>
                        <b-link @click="toggleDetails('q_someone_det')">{{ q_someone_det ? "Hide Details" : "Add Details" }}</b-link>
                        <b-form-textarea v-if="q_someone_det" class="mt-3" :rows="3" placeholder="Enter Details" name='d_someone' v-model="assessment.d_someone"></b-form-textarea>
                    </b-form-group>
                </b-list-group-item>
            </b-list-group>
        </b-tab>

        <b-tab title="Location">
            <h4 class="introduction-text">Select your Lighthouse Indicators Location and Program:</h4>
            <p>Select the location and/or program where this Lighthouse Indicators screening occurred. If no location/program is selected, it will default to the primary location/program of the organization.</p>
            <b-form-group
                label-size='lg'
                label="Location"
                label-class='addpersonlabel'
                label-for="location"
                style="width: 300px"
            >
                <b-form-select size="lg"
                  :options="locationOptions"
                  text-field="text"
                  v-model="assessment.location"
                  placeholder="Select a location">
                </b-form-select>
            </b-form-group>

            <b-form-group
                label-size='lg'
                label="Program"
                label-class='addpersonlabel'
                label-for="program"
                style="width: 300px"
            >
                <b-form-select size="lg"
                  :options="programOptions" v-model="assessment.program"
                  placeholder="Select a program">
                </b-form-select>
            </b-form-group>
        </b-tab>

        <b-tab title="Conclusion">
            <h4>Conclusion</h4>
            <b-list-group style="border: none">
                <b-list-group-item class="pl-1" style="border: none;">
                    <b-form-group label-size='lg' label-class='addpersonlabel' label='Check one of the boxes below:' label-for='concl'>
                        <p-radio class="p-round p-smooth p-plain" name='concl' color="success" v-model="assessment.dmst_conclusion" value="No">Not Enough Information</p-radio>
                        <p-radio class="p-round p-smooth p-plain" name='concl' color="red" v-model="assessment.dmst_conclusion" value="Yes">Possible Trafficking Victim</p-radio>
                    </b-form-group>
                </b-list-group-item>
            </b-list-group>
        </b-tab>
        <div class='button-container'>
          <b-button variant="outline-primary" v-show="tab_index > 0" @click="backward" class='prevBtn'>Previous</b-button>
            <b-button variant="primary" v-show="tab_index < 6" @click="forward">Next</b-button>
            <b-button variant="primary" v-show="tab_index == 6" @click="$emit('addOrUpdate')">Submit</b-button>
          </div>
        </b-card>
    </b-tabs>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'assessmentform',
  props: {
    locations: {
      type: Array,
      default: () => { return [] }
    },
    programs: {
      type: Array,
      default: () => { return [] }
    },
    assessment: {
      type: Object,
      default: () => { return {} }
    }
  },
  computed: {
    ...mapGetters({
      assessmentFields: 'getAssessmentFields'
    }),
    hasLocations () {
      return (this.locations && this.locations.length > 0)
    },
    hasPrograms () {
      return (this.programs && this.programs.length > 0)
    }
  },

  inject: ['$validator'],

  data: function () {
    return {
      errors: [],
      counter: 0,
      max: 100,
      tab_index: 1,

      // State to control toggling of details fields
      q_do_something_det: false,
      q_s_det: false,
      q_doctor_det: false,
      q_anybody_det: false,
      q_could_not_leave_det: false,
      q_finding_det: false,
      q_someone_det: false,
      q_bullied_det: false,
      locationOptions: [],
      programOptions: [],
      defaultLocation: -1,
      defaultProgram: -1
    }
  },

  created () {
      if (this.hasPrograms) {
        this.setProgramOptions()
        this.setProgramByDefault()
      }

      if (this.hasLocations) {
        this.setLocationOptions()
        this.setLocationByDefault()
      }
  },

  watch: {
    programs: function (newValue) {
      if (newValue) {
        this.setProgramOptions()
        this.setProgramByDefault()
      }
    },
    locations: function (newValue) {
      if (newValue) {
        this.setLocationOptions()
        this.setLocationByDefault()
      }
    },
    assessment: {
      handler (newValue) {
        if (newValue.location) {
          this.setLocationByDefault()
        }
        if (newValue.program) {
          this.setProgramByDefault()
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    setLocationOptions () {
      let clonedValue = Object.assign([], this.locations)
      clonedValue.sort((a, b) => a.title < b.title ? -1 : a.title > b.title ? 1 : 0)
      this.locationOptions = clonedValue
        .filter((loc) => !loc.isRemoved)
        .map((location) => {
          return {value: location.id, text: location.title}
        })
    },
    setProgramOptions () {
      let clonedValue = Object.assign([], this.programs)
      clonedValue.sort((a, b) => a.title < b.title ? -1 : a.title > b.title ? 1 : 0)
      this.programOptions = clonedValue.map((program) => {
        let text = program.title
        if (program.title === 'Other') {
          text = program.title_otherText
        }
        return {value: program.id, text}
      })
    },
    setLocationByDefault () {
      if (!this.assessment.location && this.locations.length) {
        this.assessment.location = this.locations[0].id
      } else if (typeof this.assessment.location === 'object') {
        this.assessment.location = this.assessment.location.id
      }
    },
    setProgramByDefault () {
      if (!this.assessment.program && this.programs.length) {
        this.assessment.program = this.programs[0].id
      } else if (typeof this.assessment.program === 'object') {
        this.assessment.program = this.assessment.program.id
      }
    },
    setAssessmentLocation (selected) {
      this.assessment.location = selected.selectedObject.id
    },
    setAssessmentProgram (selected) {
      this.assessment.program = selected.selectedObject.id
    },
    toggleDetails (name) {
      if (!this._.isUndefined(this[name])) {
        this[name] = !this[name]
      }
    },
    backward (event) {
      const weight = this.hasLocations ? 20 : 25

      this.tab_index--
      this.counter = this.counter - weight
      window.scrollTo(0, 0)
    },
    forward (event) {
      const weight = this.hasLocations ? 20 : 25

      this.tab_index++
      this.counter = this.counter + weight
      window.scrollTo(0, 0)
    },
    excludes: function () {
      return [
        // 'my_field'
      ]
    },
    getFields: function (categoryName) {
      let fields = this.assessmentFields
      let exclusions = this.excludes()
      let _ = this._

      fields = _.filter(fields, function (field) {
        // Check our exclusions list
        if (_.includes(exclusions, field.name)) {
          return false
        }

        // Check our category
        if (field.category !== categoryName) {
          return false
        }

        // Anything else is a big thumbs up
        return true
      })

      return fields
    }
  }

}
</script>


// WEBPACK FOOTER //
// src/views/t1/AssessmentForm.vue